import { BannerInfo } from 'banner/Banner'
import { useEffect, useState } from 'react'

// Determine if CMS Banner is displayed above nav
// Used to calculate dynamic container CSS height
export const useHasCmsBanner = () => {
  const [hasCmsBanner, setHasCmsBanner] = useState(false)

  useEffect(() => {
    if (sessionStorage) {
      const cmsBanner = sessionStorage.getItem('cmsBanner')
      if (cmsBanner) {
        const banner: BannerInfo = JSON.parse(cmsBanner)
        if (banner && banner.type !== 'empty') {
          setHasCmsBanner(true)
        }
      }
    }
  }, [])

  return { hasCmsBanner }
}
